/**
 * Prefix identity/account-management puts on the gRPC status message of every
 * proof-token rejection (missing, expired, consumed, or bound elsewhere). The
 * status message is the only part surviving api-gateway-lib's ProtoErrorHandler
 * on the HTTP path, so the `ErrorInfo` detail never reaches a browser client.
 */
export const STEP_UP_PROOF_TOKEN_ERROR_PREFIX = 'STEP_UP_PROOF_TOKEN_INVALID: ';

/**
 * Matched per line because `ApiError` joins a multi-error response body with
 * newlines, and as a prefix rather than a substring so a message merely quoting
 * the reason is not mistaken for a rejection.
 */
export function isStepUpProofTokenError(error: unknown): boolean {
  return (
    error instanceof Error &&
    error.message.split('\n').some((line) => line.startsWith(STEP_UP_PROOF_TOKEN_ERROR_PREFIX))
  );
}
